import React, { useEffect, useState } from "react";

// Components

import About from "./About";
import Experience from "./Experience";
import Projects from "./Projects";
import Resume from "./Resume";

// --- MUI Components & Styling ---
import {
  Fade,
  Fab,
} from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { useTheme } from "@mui/material/styles";

export default function Home() {

  const theme = useTheme();
  const [showScrollButton, setShowScrollButton] = useState(false);
 

    // ***************************** Scroll to Top Logic *****************************
    const handleScroll = () => {
        if (window.pageYOffset > 300) {
            setShowScrollButton(true);
        } else {
            setShowScrollButton(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

  return (
    <>
      <Resume />

      <About />

      <Experience />

      <Projects />

      {/* Scroll to Top Button */}
      <Fade in={showScrollButton}>
        <Fab
          color="primary"
          aria-label="scroll to top"
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: theme.spacing(4),
            right: theme.spacing(4),
          }}
        >
          <ArrowUpwardIcon />
        </Fab>
      </Fade>
    </>
  );
}
